import { render, staticRenderFns } from "./DetachCustomFieldModal.vue?vue&type=template&id=327a7184"
import script from "./DetachCustomFieldModal.vue?vue&type=script&lang=ts"
export * from "./DetachCustomFieldModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports